/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox/lib/button';

import UpdateDueDate from 'components/UpdateDueDate';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import TextArea from 'components/TextArea';
import S from '../styles.scss';

const ChecklistRescheduler = props => <span>
  {props.condition === true && <ContainerDiv>
    <DropdownDiv condition={props.condition}>
      <div className={S.checklistContainer}>
        <p>{props.text}</p>
        <UpdateDueDate
          value={props.newDate || ''}
          onChange={props.handleNewDate}
          errors={props.errors}
        />
        <TextArea
          label="Notes"
          value={props.newDateNote}
          onChange={props.handleNewDateNote}
          errors={props.errors.note}
        />
        <br />
        <p>Due Date Times earlier than 8am will be set to 8am</p>
        <br />
        <Button
          label="Update Due Date"
          flat inverse ripple
          className={S.saveButton}
          onClick={props.submitNewDate}
        />
        {props.newDateError && <p className={S.checklistError}>
          {props.newDateError}
        </p>}
      </div>
    </DropdownDiv>
  </ContainerDiv>}
</span>;

ChecklistRescheduler.propTypes = {
  condition: PropTypes.bool,
  text: PropTypes.string,
  newDate: PropTypes.string,
  handleNewDate: PropTypes.func,
  errors: PropTypes.object,
  newDateNote: PropTypes.string,
  handleNewDateNote: PropTypes.func,
  submitNewDate: PropTypes.func,
  newDateError: PropTypes.string,
};

export default ChecklistRescheduler;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistRescheduler.jsx